module.exports = __webpack_public_path__ + "img/completar-espacios.de2b0edc.svg";